<template>
  <div class="app-container address-modify-page">
    <div class="filter-container">
      <el-input
        v-model.trim="listQuery.orderNo"
        class="filter-item"
        clearable
        placeholder="订单编号"
        style="width: 220px"
        @keyup.enter.native="handleFilter"
      />
      <el-input
        v-model.trim="listQuery.userId"
        class="filter-item"
        clearable
        placeholder="用户ID"
        style="width: 160px"
        @keyup.enter.native="handleFilter"
      />
      <el-select
        v-model="listQuery.status"
        class="filter-item"
        clearable
        placeholder="审核状态"
        style="width: 150px"
      >
        <el-option label="待审核" :value="0" />
        <el-option label="审核通过" :value="1" />
        <el-option label="审核驳回" :value="2" />
      </el-select>
      <DataPicker
        class="filter-item date-filter"
        params-type="create"
        start-placeholder="申请开始时间"
        end-placeholder="申请截止时间"
        @valueFunc="getPickerValueFunc"
      />
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter"
        >搜索</el-button
      >
      <el-button class="filter-item" icon="el-icon-refresh" @click="resetFilter">重置</el-button>
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      border
      fit
      size="small"
      highlight-current-row
      empty-text="暂无修改地址申请"
    >
      <el-table-column prop="orderNo" label="订单编号" min-width="190" fixed="left" />
      <el-table-column prop="userId" label="用户ID" width="100" align="center" />
      <el-table-column label="原收货信息" min-width="300">
        <template slot-scope="scope">
          <div class="contact-line">
            <strong>{{ scope.row.oldName || "-" }}</strong>
            <span>{{ scope.row.oldPhone || "-" }}</span>
          </div>
          <div class="address-text">
            {{ scope.row.oldFullAddress || scope.row.oldAddress || "-" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="申请修改为" min-width="300">
        <template slot-scope="scope">
          <div class="contact-line changed-value">
            <strong>{{ scope.row.name || "-" }}</strong>
            <span>{{ scope.row.phone || "-" }}</span>
          </div>
          <div class="address-text changed-value">
            {{ scope.row.fullAddress || scope.row.address || "-" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="申请时间" width="170" align="center">
        <template slot-scope="scope">{{ formatApiDate(scope.row.ctdate) }}</template>
      </el-table-column>
      <el-table-column label="审核状态" width="110" align="center">
        <template slot-scope="scope">
          <el-tag :type="statusType(scope.row.status)" size="small">{{
            statusText(scope.row.status)
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="auditRemark" label="审核备注" min-width="150" show-overflow-tooltip />
      <el-table-column label="审核时间" width="170" align="center">
        <template slot-scope="scope">{{ formatApiDate(scope.row.auditTime) }}</template>
      </el-table-column>
      <el-table-column label="操作" width="170" align="center" fixed="right">
        <template slot-scope="scope">
          <template v-if="scope.row.status === 0">
            <el-button type="success" size="mini" @click="openAudit(scope.row, true)"
              >通过</el-button
            >
            <el-button type="danger" size="mini" plain @click="openAudit(scope.row, false)"
              >驳回</el-button
            >
          </template>
          <span v-else class="processed-text">已处理</span>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <el-dialog
      :title="auditForm.approved ? '通过改址申请' : '驳回改址申请'"
      :visible.sync="auditVisible"
      width="480px"
      :close-on-click-modal="false"
    >
      <el-alert
        v-if="auditForm.approved"
        title="通过后，订单收货信息将更新为用户申请的新地址。"
        type="warning"
        :closable="false"
        show-icon
      />
      <el-form label-position="top" class="audit-form">
        <el-form-item label="审核备注">
          <el-input
            v-model.trim="auditForm.auditRemark"
            type="textarea"
            :rows="4"
            maxlength="200"
            show-word-limit
            :placeholder="auditForm.approved ? '选填，可记录通过原因' : '请输入驳回原因'"
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="auditVisible = false">取消</el-button>
        <el-button
          :type="auditForm.approved ? 'primary' : 'danger'"
          :loading="auditLoading"
          @click="submitAudit"
          >确认{{ auditForm.approved ? "通过" : "驳回" }}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import DataPicker from "@/views/components/dataPicker.vue";
import { auditAddressModify, getAddressModifyList } from "@/api/order";
import { formatApiDate } from "@/utils/utils";

export default {
  name: "AddressModifyList",
  components: { DataPicker },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: false,
      auditVisible: false,
      auditLoading: false,
      listQuery: {
        orderNo: "",
        userId: "",
        status: null,
        ctdateStart: null,
        ctdateEnd: null,
        page: 1,
        pageSize: 20
      },
      auditForm: {
        applyId: null,
        approved: true,
        auditRemark: ""
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    formatApiDate,
    statusText(status) {
      return ["待审核", "审核通过", "审核驳回"][status] || "未知";
    },
    statusType(status) {
      return ["warning", "success", "danger"][status] || "info";
    },
    getPickerValueFunc(type, values) {
      if (type !== "create") return;
      this.listQuery.ctdateStart = values[0] || null;
      this.listQuery.ctdateEnd = values[1] || null;
    },
    async getList() {
      this.listLoading = true;
      try {
        const params = { ...this.listQuery };
        if (!params.orderNo) delete params.orderNo;
        if (!params.userId) delete params.userId;
        if (params.status === null || params.status === "") delete params.status;
        const res = await getAddressModifyList(params);
        if (res && res.bizcode === 100 && res.data) {
          this.list = res.data.entitys || [];
          this.total = res.data.totalCount || 0;
        } else {
          this.list = [];
          this.total = 0;
        }
      } finally {
        this.listLoading = false;
      }
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    resetFilter() {
      this.listQuery = {
        orderNo: "",
        userId: "",
        status: null,
        ctdateStart: null,
        ctdateEnd: null,
        page: 1,
        pageSize: 20
      };
      this.getList();
    },
    handleSizeChange(size) {
      this.listQuery.pageSize = size;
      this.listQuery.page = 1;
      this.getList();
    },
    handleCurrentChange(page) {
      this.listQuery.page = page;
      this.getList();
    },
    openAudit(row, approved) {
      this.auditForm = {
        applyId: row.id,
        approved,
        auditRemark: ""
      };
      this.auditVisible = true;
    },
    async submitAudit() {
      if (!this.auditForm.approved && !this.auditForm.auditRemark) {
        this.$message.warning("请输入驳回原因");
        return;
      }
      this.auditLoading = true;
      try {
        const res = await auditAddressModify(this.auditForm);
        if (res && res.bizcode === 100) {
          this.$message.success(this.auditForm.approved ? "已通过改址申请" : "已驳回改址申请");
          this.auditVisible = false;
          this.getList();
        }
      } finally {
        this.auditLoading = false;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.address-modify-page {
  .filter-container {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px;
    margin-bottom: 18px;
  }

  .filter-item {
    margin: 0;
  }

  .date-filter {
    width: 360px;
    margin-right: 0 !important;
  }

  .contact-line {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 6px;
    color: #303133;
  }

  .address-text {
    color: #606266;
    line-height: 1.55;
    word-break: break-all;
  }

  .changed-value {
    color: #409eff;
  }

  .processed-text {
    color: #909399;
  }

  .audit-form {
    margin-top: 20px;
  }
}
</style>
